'use strict';

/**
 * Agrupa una lista de tipos por su categoría.
 *
 * Devuelve `{ grupos: [{cat, tipos}], sinCat: [] }`.
 *   - grupos ordenados por `cat.orden` ASC; a igual orden, alfabético por `cat.nombre`.
 *   - tipos dentro de cada grupo ordenados por `nombre`.
 *   - sinCat: tipos sin categoría (categoria null/undefined), ordenados por nombre.
 *   - Si NINGÚN tipo tiene categoría → `grupos = []` (señal al sidebar para que
 *     pinte plano, sin alterar la UX actual).
 *
 * Función pura, sin dependencias de React: testeable sin BBDD ni DOM. La importan
 * el sidebar (CRA/webpack) y los tests Node con `import { … } from './…js'`
 * (Node 24 soporta named imports estáticos desde CJS).
 */
function agruparPorCategoria(items) {
  const sinCat = [];
  const mapa = new Map(); // id → { cat, tipos:[] }

  const arr = Array.isArray(items) ? items : [];
  for (const t of arr) {
    const cat = t && t.categoria;
    if (cat && cat.id != null) {
      if (!mapa.has(cat.id)) mapa.set(cat.id, { cat, tipos: [] });
      mapa.get(cat.id).tipos.push(t);
    } else {
      sinCat.push(t);
    }
  }

  const byName = (a, b) =>
    String(a.nombre || '').localeCompare(String(b.nombre || ''));

  const grupos = Array.from(mapa.values());
  for (const g of grupos) g.tipos.sort(byName);
  grupos.sort((a, b) => {
    const oa = Number.isFinite(a.cat.orden) ? a.cat.orden : 0;
    const ob = Number.isFinite(b.cat.orden) ? b.cat.orden : 0;
    if (oa !== ob) return oa - ob;
    return String(a.cat.nombre || '').localeCompare(String(b.cat.nombre || ''));
  });

  sinCat.sort(byName);
  return { grupos, sinCat };
}

module.exports = { agruparPorCategoria };
